/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Syntax_Errors_Faq_A4Inputs */

const en_guide_json_syntax_errors_faq_a4 = /** @type {(inputs: Guide_Json_Syntax_Errors_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste the text into a validating editor. It highlights the first line and column where parsing breaks, so instead of scanning the whole document you can jump straight to the problem.`)
};

const ko_guide_json_syntax_errors_faq_a4 = /** @type {(inputs: Guide_Json_Syntax_Errors_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`검증 기능이 있는 에디터에 텍스트를 붙여넣으세요. 파싱이 깨지는 첫 줄과 열을 강조해 주므로 문서 전체를 훑는 대신 문제 지점으로 바로 갈 수 있습니다.`)
};

const ja_guide_json_syntax_errors_faq_a4 = /** @type {(inputs: Guide_Json_Syntax_Errors_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`検証機能のあるエディターにテキストを貼り付けます。パースが壊れる最初の行と列を強調してくれるので、文書全体を追う代わりに問題の箇所へ直接飛べます。`)
};

/**
* | output |
* | --- |
* | "Paste the text into a validating editor. It highlights the first line and column where parsing breaks, so instead of scanning the whole document you can jump..." |
*
* @param {Guide_Json_Syntax_Errors_Faq_A4Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_syntax_errors_faq_a4 = /** @type {((inputs?: Guide_Json_Syntax_Errors_Faq_A4Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Syntax_Errors_Faq_A4Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_syntax_errors_faq_a4(inputs)
	if (locale === "ko") return ko_guide_json_syntax_errors_faq_a4(inputs)
	return ja_guide_json_syntax_errors_faq_a4(inputs)
});